import { logger } from "../core/logger";
import { subscribe, THEME_EVENTS } from "../../shared/events";

class CartPage extends HTMLElement {
  connectedCallback() {
    this.refreshNotice = this.querySelector("[data-cart-refresh-notice]");
    this.refreshButton = this.querySelector("[data-refresh-cart-page]");

    this.onRefreshClick = this.onRefreshClick.bind(this);

    this.refreshButton?.addEventListener("click", this.onRefreshClick);

    this.cartUpdateUnsubscriber = subscribe(
      THEME_EVENTS.cartUpdate,
      (event) => {
        logger.info("CartPage", "cartUpdate", event.source);
        this.showRefreshNotice();
      },
    );

    logger.info("CartPage", "connected");
  }

  disconnectedCallback() {
    this.refreshButton?.removeEventListener("click", this.onRefreshClick);

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    logger.info("CartPage", "disconnected");
  }

  showRefreshNotice() {
    this.refreshNotice?.classList.remove("hidden");
  }

  onRefreshClick() {
    window.location.reload();
  }
}

if (!customElements.get("cart-page")) {
  customElements.define("cart-page", CartPage);
}
